<input type="text" class="form-control" [id]="id" [name]="name" [(ngModel)]="zipCode" mask="00000"
	[placeholder]="placeholder" [required]="required" [readonly]="readonly" [disabled]="disabled" autocomplete="off" />

<!-- [textMask]="zipCodeMask" -->
